import React from 'react'
import './Footer.css'
import {  AiOutlineWhatsApp, AiFillFacebook, AiOutlineInstagram, AiFillYoutube } from 'react-icons/ai'
import { FaTelegram } from 'react-icons/fa'
import { AiFillLinkedin } from 'react-icons/ai'

import { FaXTwitter } from "react-icons/fa6";

export default function Footer() {
    return (
        <div style={{zIndex:100,backgroundColor:"black",position:"relative"}}>
            <div className='footer_section'>
                <div className='download_app_section'>
                    <p className='footer_headings'>Find Us On</p>
                    <div className='storeimages'>
                        <img src='/playstore.png' alt='playstore' className='playstore_image' onClick={() => window.open('https://play.google.com/store/apps/details?id=com.datavizon.courses&hl=en-IN', '_blank')}></img>
                        <img src='/appstore.png' alt='appstore' className='playstore_image' onClick={() => window.open('https://apps.apple.com/in/app/ksr-datavizon/id1611034268', '_blank')}></img>
                    </div>
                </div>

                <div className='contactus_section'>
                    <p className='footer_headings contact-heading'>Contact Us</p>
                    <p className='footer_text' style={{marginTop:'35px'}}>Hyderabad & Bengaluru</p>
                    <p>Call : +91 9916961234</p>
                    <p>support@datavizon.com</p>
                </div>

                <div>
                    <p className='footer_headings courses-header-footer'>Courses</p>
                    <div className='footer_courses_list'>
                        <a className='footer_text1' style={{marginTop:"-5px"}} target='_blank' rel="noreferrer" href='https://ksrdatavizon.com/courses/data-science-with-generative-ai/'>Data Science With Generative AI</a>
                        <a className='footer_text1' target='_blank' rel="noreferrer" href='https://ksrdatavizon.com/courses/multi-cloud-snowflake-data-engineering/'>Multi Cloud Snowflake Data Engineering</a>
                        <a className='footer_text1' target='_blank' rel="noreferrer" href='https://ksrdatavizon.com/courses/power-platform-developer/'>Power Platform Developer</a>
                        <a className='footer_text1' target='_blank' rel="noreferrer" href='https://ksrdatavizon.com/courses/full-stack-powerbi-ms-fabric-azure/'>Azure MS Fabric Power BI</a>
                        <a className='footer_text1' target='_blank' rel="noreferrer" href='https://ksrdatavizon.com/course/Full Stack PowerBI with MS Fabric Tools'>Full Stack PowerBI with MS Fabric & Azure</a>
                        <a className='footer_text1' target='_blank' rel="noreferrer" href='https://ksrdatavizon.com/courses/multi-cloud-devops-mlops/'>Multi Cloud Devops with MLOPS</a>

                    </div>
                </div>

                <div className='social_media_section1' >
                    <p className='footer_headings'>Follow Us</p>
                    <p className='footer_text1' style={{marginTop:"-10px"}}>Social Media</p>
                    <div className='social_media_icons'>

                        <a href='https://twitter.com/ksrdatavizon' target='_blank' rel="noreferrer"><FaXTwitter className='footer_icons'/></a>
                        <a href='https://www.facebook.com/KSRConsultingServices/' target='_blank' rel="noreferrer"><AiFillFacebook className='footer_icons' /></a>
                        <a href='https://www.instagram.com/ksr_datavision/' target='_blank' rel="noreferrer"> <AiOutlineInstagram className='footer_icons' /></a>
                        <a href='https://wa.me/918951796123' target='_blank' rel="noreferrer"><AiOutlineWhatsApp className='footer_icons' /></a>
                        <a href='https://t.me/ksrdatavizon' target='_blank' rel="noreferrer"><FaTelegram className='footer_icons' /></a>
                        <a href='https://twitter.com/ksrdatavizon?lang=en' target='_blank' rel="noreferrer"><AiFillYoutube className='footer_icons' /></a>
                        <a href='https://www.linkedin.com/company/datavizon/' target='_blank' rel="noreferrer" style={{ paddingLeft: "5px" }}><AiFillLinkedin className='footer_icons' /></a>



                    </div>

                </div>

            </div>

            <div >
                <p className='sub_footer'>© 2026 KSR DataVizon | All Rights Reserved </p>
            </div>
        </div>

    )
}
